<template>
  <span class="operation-help-trigger">
    <el-button :type="buttonType" :plain="plain" :size="size" :icon="icon" @click="visible = true">
      {{ buttonText }}
    </el-button>
    <operation-help-dialog
      v-model="visible"
      :document="resolvedDocument"
      :title-suffix="titleSuffix"
      :close-text="closeText"
    />
  </span>
</template>

<script>
import OperationHelpDialog from "./OperationHelpDialog.vue";
import { createEmptyHelpDocument, resolveHelpDocument } from "./helpRegistry";

export default {
  name: "OperationHelp",
  components: { OperationHelpDialog },
  props: {
    document: { type: Object, default: null },
    namespace: { type: String, default: "" },
    helpKey: { type: String, default: "" },
    context: { type: Object, default: () => ({}) },
    buttonText: { type: String, default: "操作帮助" },
    buttonType: { type: String, default: "primary" },
    plain: { type: Boolean, default: true },
    size: { type: String, default: "default" },
    icon: { type: String, default: "QuestionFilled" },
    titleSuffix: { type: String, default: "操作帮助" },
    closeText: { type: String, default: "我知道了" }
  },
  data() {
    return { visible: false };
  },
  computed: {
    resolvedDocument() {
      if (this.document) return this.document;
      if (this.namespace && this.helpKey) {
        return resolveHelpDocument(this.namespace, this.helpKey, this.context);
      }
      return createEmptyHelpDocument(this.namespace, this.helpKey);
    }
  }
};
</script>
